import { Dispatch } from 'react';
import { type } from '../constants/C2CModalConstant'
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import { cloneDeep, isEmpty } from 'lodash';

export const openC2CModal = (source: string, modalTitle: React.ReactNode | string = '', initialSchema: any = null, passedProps: any = null) => {

    return (dispatch: Dispatch<any>) => {
        dispatch({
            type: type.SHOW_C2C_MODAL,
            payload: {
                modalSource: source || '',
                modalTitle: modalTitle || 'New Conversation',
                initialSchema: initialSchema,
                passedProps: cloneDeep(passedProps),
            }
        });
    }
}

export const closeC2CModal = () => {

    return (dispatch: Dispatch<any>) => {
        dispatch({
            type: type.HIDE_C2C_MODAL
        });
    }
}

export const getGlobalC2COption = () => {

    return (dispatch: Dispatch<any>) => {
        networkCall("get", `/get-global-conversation`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (isEmpty(res.error)) {
                    dispatch({ type: type.C2C_GLOBAL_OPTION_SUCCESS, payload: { res: res.data } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    console.log(error.response)
                }
            });
    }
}

export const clickToCall = (data: any, cbSuccess: (msg: string) => void, cbError: (errorMsg:string) => void) => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: type.C2C_CALL_INITIATED })

        networkCall("post", `/start-conversation`, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.data) {
                    dispatch({ type: type.C2C_CALL_SUCCESS, payload: { res: res.data } });
                    cbSuccess(res.data.message)
                } else {
                    dispatch({ type: type.C2C_CALL_FAILED, payload: { error: res.error.message } });
                    cbError(res.error.message)
                }
            }).catch((error) => {
                console.log(error.response.data)
                if (error?.response?.data) {
                    dispatch({ type: type.C2C_CALL_FAILED, payload: { error } });
                    cbError(error)
                }
            });
    }
}
